import { Controller } from "@hotwired/stimulus"

// This controller helps to preview a Image selected from a file input
export default class extends Controller {
  static targets = ['dayForm', 'dayButton'];

  connect() {
    console.debug("Mobile Calendar", this.dayFormTarget);

    this.showCurrentDayButton();
  }

  disconnect() {
  }


  showCurrentDayButton() {
    const currentButton = this.dayFormTarget.querySelector('button.btn.active')

    if (currentButton) {
      currentButton.scrollIntoView({inline: "start"});
    }
  }

  setActive(event) {
    for (const dayButtonTarget of this.dayButtonTargets) {
       dayButtonTarget.classList.remove('active');
    }
    event.target.closest('.btn').classList.add('active');
  }
}